import Text from 'components/3catinfo/Text';
import __isEmpty from 'lodash/isEmpty';
import styles from './puntsClau.module.scss';

const PuntsClau = (props) => {
    const { cos } = props;

    return !__isEmpty(cos) ? (
        <div className={styles.puntsClau} data-testid='item-noti-puntsclau'>
            <h3>Els punts clau</h3>
            <Text text={cos} />
        </div>
    ) : (
        <></>
    );
};

export default PuntsClau;
